import { createFileRoute } from '@tanstack/react-router'
import { AudioMaskPage } from '@/features/audiomask/AudioMaskPage'

export const Route = createFileRoute('/_authenticated/audio-mask')({
  component: AudioMaskPage,
})
